import { useNavigate } from "react-router-dom";
import {
    recent8Months,
    toDateWeekdayTimeString,
    toMonthString,
    useNow,
} from "../../date_utils";
import { useMemo, useEffect, useContext, useState } from "react";
import { Chart } from "react-charts";
import { mergeClasses } from "@fluentui/react-components";
// import mapdata from "../../map.json";

import * as echarts from "echarts";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useElementSize, useWindowSize } from "usehooks-ts";
import "leaflet.chinatmsproviders";

// import AMap from "echarts-extension-amap/export";

// import {
//     ScatterChart,
//     ScatterSeriesOption,
//     EffectScatterChart,
//     EffectScatterSeriesOption,
// } from "echarts/charts";

import {
    ResponsiveContainer,
    RadarChart,
    Radar,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    PieChart,
    Pie,
    Cell,
    Legend,
} from "recharts";
import { Context } from "../../context";
import { dashboardService } from "../../services/dashboard_service";

// import { TooltipComponent, TitleComponentOption } from "echarts/components";
// import { CanvasRenderer } from "echarts/renderers";

// import ReactECharts from "echarts-for-react";
// import * as AMapExp from "echarts-extension-amap";

// import "@amap/amap-jsapi-types";

// install as AMapComponent,
// AMapComponentOption,
// const AMapComponent = AMapExp.install;
// const AMapComponentOption = AMapExp.AMapComponentOption;
// 注册渲染器、组件和图表
// echarts.use([
//     CanvasRenderer,
//     TooltipComponent,
//     AMapComponent,
//     ScatterChart,
//     EffectScatterChart,
// ]);
const Title = ({ title, subTitle = null }) => {
    return (
        <div>
            <div className="flex flex-row mb-1">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                >
                    <rect x="4" y="4" width="4" height="4" fill="#3DFFFF" />
                </svg>
                <span
                    style={{
                        fontFamily: "Microsoft YaHei",
                        fontSize: "16px",
                        fontWeight: 700,
                        lineHeight: "16px",
                        color: "#fff",
                    }}
                >
                    {title}
                </span>
                {subTitle && (
                    <span
                        style={{
                            color: "rgba(255,255,255,0.4)",
                            fontFamily: "Microsoft YaHei",
                            fontSize: 10,
                            fontStyle: "normal",
                            fontWeight: 400,
                            marginLeft: "4px",
                        }}
                    >
                        {subTitle}
                    </span>
                )}
            </div>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="120"
                height="2"
                viewBox="0 0 120 2"
                fill="none"
            >
                <rect width="120" height="2" fill="#3DFFFF" />
            </svg>
        </div>
    );
};

const ArrowUp = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
        >
            <path d="M5 0L10 10H0L5 0Z" fill="#81DC6F" />
        </svg>
    );
};
const ArrowDown = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="11"
            viewBox="0 0 10 11"
            fill="none"
        >
            <path d="M5 10.4287L10 0.428711H0L5 10.4287Z" fill="#D85766" />
        </svg>
    );
};

const Progress = ({ value, style, ...props }) => {
    style = {
        backgroundColor: "rgba(255, 255,255,0.1)",
        display: "flex",
        height: "4px",

        ...style,
    };
    return (
        <div style={style} {...props}>
            <div
                style={{
                    background:
                        "linear-gradient(270deg, #1890FF 0%, #1EE7E7 100%)",
                    width: `${value}%`,
                    height: "4px",
                    borderRadius: "2px",
                }}
            ></div>
        </div>
    );
};
const FieldStatItem = ({
    arrow = null,
    no,
    name,
    turbineCount,
    maxTurbineCount,
}) => {
    return (
        <div className="flex flex-col">
            <div className="flex flex-row flex-1 items-center">
                {(arrow == "up" && <ArrowUp />) ||
                    (arrow == "down" && <ArrowDown />) || (
                        <div style={{ width: 10 }}></div>
                    )}
                <div
                    style={{
                        marginLeft: "4px",
                        fontFamily: "Microsoft YaHei",
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "#fff",
                        marginRight: "8px",
                    }}
                >
                    No.{no}
                </div>
                <div
                    style={{
                        fontFamily: "Microsoft YaHei",
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#fff",
                        marginRight: "32px",
                    }}
                >
                    {name}
                </div>
                <div className="flex-1"></div>
                <div>
                    <span
                        style={{
                            fontFamily: "Microsoft YaHei",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#fff",
                        }}
                    >
                        {turbineCount}
                    </span>
                    <span
                        style={{
                            color: "rgba(230,247,255,0.5)",
                            fontFamily: "Microsoft YaHei",
                            fontSize: "14px",
                            fontWeight: 400,
                        }}
                    >
                        /台
                    </span>
                </div>
            </div>
            <Progress
                value={(turbineCount * 100) / maxTurbineCount}
                style={{ marginTop: "4px" }}
            />
        </div>
    );
};
const FieldStat = ({ className, ...otherProps } = {}) => {
    const { db } = useContext(Context);
    useEffect(() => {
        if (!db) {
            return;
        }
        loadData();
    }, [db]);
    const { width: windowWidth } = useWindowSize();
    const [ref, { width, height }] = useElementSize();
    let w = ((width + 46) * 100) / windowWidth;
    if (width > 0) {
        document.body.style.setProperty("--dashboard-left-width", `${w}%`);
    }
    // const items = [
    //     { name: "XXXXX港风场", turbineCount: 37 },
    //     { name: "XXXX港风场", turbineCount: 35 },
    //     { name: "XXXX海面风场", turbineCount: 34 },
    //     { name: "XXX风场", turbineCount: 33 },
    //     { name: "XXX风场", turbineCount: 32 },
    //     { name: "XXX风场", turbineCount: 31 },
    //     { name: "XXX风场", turbineCount: 29 },
    //     { name: "XXX风场", turbineCount: 25 },
    // ];
    const [maxTurbineCount, setMaxTurbineCount] = useState(10);
    const [items, setItems] = useState([]);
    const loadData = async () => {
        console.warn("loadData function for field items is not yet implemented in backend");
        try {
            const items = [];
            console.log("field_items:", items);
            setItems(items);

            if (items.length > 0) {
                setMaxTurbineCount(items[0].turbineCount);
            }
        } catch (error) {
            console.error("Error in loadData:", error);
            setItems([]);
        }
    };

    return (
        <div
            className={mergeClasses(
                "flex flex-col row-span-2 ml-10",
                className,
            )}
            ref={ref}
            {...otherProps}
        >
            <Title title="风场规模" />
            <div className="flex flex-col gap-4 mt-4 ml-2">
                {items.map((item, i) => (
                    <FieldStatItem
                        arrow={(i == 0 && "up") || (i == 1 && "down") || null}
                        key={i}
                        no={i + 1}
                        name={item.name}
                        turbineCount={item.turbineCount}
                        maxTurbineCount={maxTurbineCount}
                    />
                ))}
            </div>
        </div>
    );
};

const statTurbine = async () => {
    console.warn("statTurbine function is not yet implemented in backend");
    try {
        return [];
    } catch (error) {
        console.error("Error in statTurbine:", error);
        return [];
    }
};

const TurbineStat = ({}) => {
    const { db } = useContext(Context);
    const [data, setData] = useState([]);
    const loadData = async () => {
        console.log("loadData");
        let data = await statTurbine();
        setData(data);
    };
    useEffect(() => {
        if (!db) {
            return;
        }
        loadData();
    }, [db]);
    // const data = useMemo(
    //     () => [
    //         {
    //             name: "系列一",
    //             value: 30,
    //         },
    //         {
    //             name: "系列二",
    //             value: 5,
    //         },
    //         {
    //             name: "系列三",
    //             value: 25,
    //         },
    //         {
    //             name: "系列四",
    //             value: 70,
    //         },
    //     ],
    //     []
    // );
    const COLORS = ["#53DD48", "#7CD2F5", "#4D74FF", "#FFCF5F"];
    return (
        <div className="flex flex-col ml-12">
            <Title title="风机类型" />
            <ResponsiveContainer
                width="100%"
                height="100%"
                className="flex-1 flex scale-90"
            >
                <PieChart className="flex-1">
                    <Pie
                        data={data}
                        dataKey="value"
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={80}
                        fill="#4D74FF"
                        stroke="none"
                        style={{ transform: "translateX(-80px)" }}
                        label
                    >
                        {data.map((datum, index) => (
                            <Cell
                                key={index}
                                fill={COLORS[index % COLORS.length]}
                            />
                        ))}
                    </Pie>
                    <Legend verticalAlign="bottom" align="left" />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

const UserStatItem = ({ label, count, unit }) => {
    return (
        <div className="flex flex-col gap-2">
            <div
                style={{
                    color: "#A8D6FF",
                    fontFamily: "Microsoft YaHei",
                    fontSize: "14px",
                    fontWeight: 400,
                }}
            >
                {label}
            </div>
            <div>
                <span
                    style={{
                        color: "#E1DFDD",
                        fontFamily: "Microsoft YaHei",
                        fontSize: "28px",
                        fontWeight: 700,
                    }}
                >
                    {count}
                </span>
                <span
                    style={{
                        color: "rgba(168,214,255,0.64)",
                        fontFamily: "Microsoft YaHei",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "200%",
                        marginLeft: "2px",
                    }}
                >
                    {unit}
                </span>
            </div>
        </div>
    );
};

const statUser = async () => {
    console.warn("statUser function is not yet implemented in backend");
    try {
        return [];
    } catch (error) {
        console.error("Error in statUser:", error);
        return [];
    }
};

const UserStat = () => {
    const { db } = useContext(Context);
    const [data, setData] = useState([]);
    const loadData = async () => {
        let data = await statUser();
        setData(data);
    };
    useEffect(() => {
        if (!db) {
            return;
        }
        loadData();
    }, [db]);

    const COLORS = ["#54E1AA", "#CBDA81", "#476AE7"];
    // const data = useMemo(
    //     () => [
    //         {
    //             name: "负责人",
    //             value: 27,
    //         },
    //         {
    //             name: "管理人员",
    //             value: 86,
    //         },
    //         {
    //             name: "巡检人员",
    //             value: 271,
    //         },
    //     ],
    //     []
    // );
    return (
        <div className="flex flex-col ml-12">
            <Title title="人员配备" />
            <div className="flex-1 flex flex-row scale-90">
                <ResponsiveContainer className="flex-1">
                    <PieChart className="flex-1">
                        <Pie
                            data={data}
                            dataKey="value"
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={70}
                            fill="#CBDA81"
                            stroke="nonoe"
                            label
                        >
                            {data.map((datum, index) => (
                                <Cell
                                    key={index}
                                    fill={COLORS[index % COLORS.length]}
                                />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
                <div className="flex-1 flex flex-col justify-center ml-10 gap-4 w-[120px]">
                    <UserStatItem
                        label="巡检人员"
                        count={data.find((it) => it.name === "员工")?.value}
                        unit="人"
                    />
                    <UserStatItem
                        label="管理人员"
                        count={
                            data.find((it) => it.name === "风场管理员")?.value
                        }
                        unit="人"
                    />
                </div>
            </div>
        </div>
    );
};

const statTask = async () => {
    try {
        console.warn('statTask not yet implemented in backend');
        return [];
    } catch (error) {
        console.error('Failed to load task stats:', error);
        return [];
    }
};

const TaskStat = () => {
    const { db } = useContext(Context);
    const [data, setData] = useState([]);
    const [secondaryMax, setSecondaryMax] = useState(600);
    const { width: windowWidth } = useWindowSize();
    const [ref, { width, height }] = useElementSize();
    if (width > 0) {
        let w = ((width + 40) * 100) / windowWidth;
        document.body.style.setProperty("--dashboard-right-width", `${w}%`);
    }
    const loadData = async () => {
        let data = await statTask();
        data = data.map((it) => ({
            month: toMonthString(it.created_month),
            count: it.count,
            rate: 0,
        }));
        let secondaryMax =
            Math.max.apply(
                Math.max,
                data.map((it) => it.count),
            ) || 598;
        secondaryMax += 2;
        setSecondaryMax(secondaryMax);
        let months = recent8Months();
        data = months.map((month) => {
            let d = data.find((d) => d.month === month);
            return d || { month, count: 0, rate: 0 };
        });
        data = [
            {
                label: "任务量",
                secondaryAxisId: "1",
                data,
            },
        ];
        console.log("statTask:", data);
        setData(data);
    };
    useEffect(() => {
        if (!db) {
            return;
        }
        loadData();
    }, [db]);
    // const data = useMemo(() => {
    //     return [
    //         {
    //             label: "任务量",
    //             secondaryAxisId: "1",
    //             data: [
    //                 {
    //                     month: "1月",
    //                     count: 420,
    //                     rate: 280,
    //                 },
    //                 {
    //                     month: "2月",
    //                     count: 420,
    //                     rate: 420,
    //                 },
    //                 {
    //                     month: "3月",
    //                     count: 420,
    //                     rate: 520,
    //                 },
    //                 {
    //                     month: "4月",
    //                     count: 420,
    //                     rate: 380,
    //                 },
    //                 {
    //                     month: "5月",
    //                     count: 420,
    //                     rate: 240,
    //                 },
    //                 {
    //                     month: "6月",
    //                     count: 420,
    //                     rate: 470,
    //                 },
    //             ],
    //         },
    //         // {
    //         //     label: "增长率",
    //         //     secondaryAxisId: "2",
    //         //     data: [
    //         //         {
    //         //             month: "1月",
    //         //             // count: 420,
    //         //             count: 280,
    //         //             // rate:  280,
    //         //         },
    //         //         {
    //         //             month: "2月",
    //         //             // count: 420,
    //         //             // rate: 420,
    //         //             count: 420,
    //         //         },
    //         //         {
    //         //             month: "3月",
    //         //             // count: 420,
    //         //             // rate: 520,
    //         //             count: 520,
    //         //         },
    //         //         {
    //         //             month: "4月",
    //         //             // count: 420,
    //         //             // rate: 380,
    //         //             count: 380,
    //         //         },
    //         //         {
    //         //             month: "5月",
    //         //             // count: 420,
    //         //             // rate: 240,
    //         //             count: 240,
    //         //         },
    //         //         {
    //         //             month: "6月",
    //         //             // count: 420,
    //         //             // rate: 470,
    //         //             count: 470,
    //         //         },
    //         //     ],
    //         // },
    //     ];
    // }, []);
    const primaryAxis = useMemo(() => {
        return {
            getValue: (datum) => datum.month,
            scaleType: "band",
            // padBandRange: true,
            id: "1",
        };
    }, []);
    const secondaryAxes = useMemo(() => {
        return [
            {
                id: "1",
                getValue: (datum) => datum.count,
                min: 0,
                max: secondaryMax,
                elementType: "bar",
            },
            // {
            //     id: "2",
            //     getValue: (datum) => datum.count,
            //     // min: 0,
            //     // max: 800,
            //     elementType: "line",
            // },
        ];
    }, [secondaryMax]);
    return (
        <div className="flex flex-col mr-8" ref={ref}>
            <Title title="巡检任务" />
            {data.length > 0 && (
                <Chart
                    options={{
                        data,
                        primaryAxis,
                        secondaryAxes,
                        dark: true,
                        padding: {
                            left: 20,
                            top: 40,
                            right: 20,
                            bottom: 40,
                        },

                        renderSVG: () => {
                            return (
                                <defs>
                                    <linearGradient
                                        id="bar"
                                        x1="0"
                                        x2="1"
                                        y1="0"
                                        y2="0"
                                    >
                                        <stop offset="0%" stopColor="#1890FF" />
                                        <stop
                                            offset="100%"
                                            stopColor="#1EE7E7"
                                        />
                                    </linearGradient>
                                </defs>
                            );
                        },
                        getSeriesStyle: (series, status) => {
                            return {
                                color: "url(#bar)",
                                width: 10,
                                transform: "translate(6px, 0)",
                            };
                        },
                    }}
                />
            )}
        </div>
    );
};

const statHumanDefectionCountByMonth = async () => {
    console.warn("statHumanDefectionCountByMonth function is not yet implemented in backend");
    try {
        return [];
    } catch (error) {
        console.error("Error in statHumanDefectionCountByMonth:", error);
        return [];
    }
};
const statAiDefectionCountByMonth = async () => {
    console.warn("statAiDefectionCountByMonth function is not yet implemented in backend");
    try {
        return [];
    } catch (error) {
        console.error("Error in statAiDefectionCountByMonth:", error);
        return [];
    }
};
const zipWithMonth = (months, data) => {
    return months.map((month) => {
        return data.find((d) => d.month == month) || { month, count: 0 };
    });
};
const maxCountInArray = (array, minValue = 0, gap = 4) => {
    let m = Math.max.apply(Math.max, array || []);
    if (m) {
        return m + gap;
    } else {
        return minValue;
    }
};

const DefectionCountByMonthStat = () => {
    const { db } = useContext(Context);
    const [aiData, setAiData] = useState([]);
    const [humanData, setHumanData] = useState([]);
    const [maxAi, setMaxAi] = useState(500);
    const [maxHuman, setMaxHuman] = useState(500);
    const loadData = async () => {
        let humanData = await statHumanDefectionCountByMonth();
        let aiData = await statAiDefectionCountByMonth();
        let months = recent8Months();
        humanData = zipWithMonth(months, humanData);
        aiData = zipWithMonth(months, aiData);
        setHumanData(humanData);
        setAiData(aiData);
        let maxHuman = maxCountInArray(humanData);
        setMaxHuman(maxHuman);
        let maxAi = maxCountInArray(aiData);
        setMaxAi(maxAi);
    };
    useEffect(() => {
        if (!db) {
            return;
        }
        loadData();
    }, [db]);
    const data = useMemo(() => {
        return [
            {
                label: "智能识别",
                data: aiData,
                // data: [
                //     {
                //         month: "1月",
                //         count: 1800,
                //     },
                //     {
                //         month: "2月",
                //         count: 3200,
                //     },
                //     {
                //         month: "3月",
                //         count: 3080,
                //     },
                //     {
                //         month: "4月",
                //         count: 3300,
                //     },
                //     {
                //         month: "5月",
                //         count: 4000,
                //     },
                //     {
                //         month: "6月",
                //         count: 4890,
                //     },
                // ],
            },
            {
                label: "人工目识",
                data: humanData,
                // data: [
                //     {
                //         month: "1月",
                //         count: 1100,
                //     },
                //     {
                //         month: "2月",
                //         count: 1600,
                //     },
                //     {
                //         month: "3月",
                //         count: 1080,
                //     },
                //     {
                //         month: "4月",
                //         count: 1300,
                //     },
                //     {
                //         month: "5月",
                //         count: 1400,
                //     },
                //     {
                //         month: "6月",
                //         count: 1000,
                //     },
                // ],
            },
        ];
    }, [aiData, humanData]);
    const primaryAxis = useMemo(() => {
        return {
            getValue: (datum) => datum.month,
        };
    }, []);
    const secondaryAxes = useMemo(() => {
        return [
            {
                getValue: (datum) => datum.count,
                elementType: "line",
                min: 0,
                max: maxAi,
            },
            {
                getValue: (datum) => datum.count,
                min: 0,
                max: maxHuman,
            },
        ];
    }, [maxHuman, maxAi]);
    return (
        <div className="flex flex-col mr-8">
            <Title title="检测数据量" />
            {(humanData.length > 0 || aiData.length > 0) && (
                <Chart
                    options={{
                        data,
                        primaryAxis,
                        secondaryAxes,
                        dark: true,
                        padding: {
                            left: 20,
                            top: 40,
                            right: 20,
                            bottom: 40,
                        },
                    }}
                />
            )}
        </div>
    );
};

const listDefectionType = async () => {
    try {
        const rets = await dashboardService.getDefectionTypes();
        return rets || [];
    } catch (error) {
        console.error('Failed to load defection types:', error);
        return [];
    }
};

const statDefectionTypeByMonthSingle = async (defDefection) => {
    try {
        // TODO: Implement backend endpoint for defection type stats by month
        console.warn('statDefectionTypeByMonthSingle not yet implemented in backend');
        return [];
    } catch (error) {
        console.error('Failed to load defection type stats by month:', error);
        return [];
    }
};

const DefectionTypeByMonthStat = () => {
    const { db } = useContext(Context);
    const [data, setData] = useState([]);
    const loadData = async () => {
        let defectionTypes = await listDefectionType();
        let months = recent8Months();
        let rets = [];
        for (let defectionType of defectionTypes) {
            let d = await statDefectionTypeByMonthSingle(defectionType);
            d = zipWithMonth(months, d);
            d = { label: defectionType.name, data: d };
            rets.push(d);
        }
        setData(rets);
    };
    useEffect(() => {
        if (!db) {
            return;
        }
        loadData();
    }, [db]);
    // const data = useMemo(
    //     () => [
    //         {
    //             label: "",
    //             data: [
    //                 {
    //                     month: "1月",
    //                     count: 11,
    //                 },
    //                 {
    //                     month: "2月",
    //                     count: 37,
    //                 },
    //                 {
    //                     month: "3月",
    //                     count: 25,
    //                 },
    //                 {
    //                     month: "4月",
    //                     count: 48,
    //                 },
    //                 {
    //                     month: "5月",
    //                     count: 32,
    //                 },
    //                 {
    //                     month: "6月",
    //                     count: 27,
    //                 },
    //             ],
    //         },
    //         {
    //             label: "",
    //             data: [
    //                 {
    //                     month: "1月",
    //                     count: 8,
    //                 },
    //                 {
    //                     month: "2月",
    //                     count: 11,
    //                 },
    //                 {
    //                     month: "3月",
    //                     count: 7,
    //                 },
    //                 {
    //                     month: "4月",
    //                     count: 13,
    //                 },
    //                 {
    //                     month: "5月",
    //                     count: 17,
    //                 },
    //                 {
    //                     month: "6月",
    //                     count: 9,
    //                 },
    //             ],
    //         },
    //         {
    //             label: "",
    //             data: [
    //                 {
    //                     month: "1月",
    //                     count: 32,
    //                 },
    //                 {
    //                     month: "2月",
    //                     count: 28,
    //                 },
    //                 {
    //                     month: "3月",
    //                     count: 47,
    //                 },
    //                 {
    //                     month: "4月",
    //                     count: 36,
    //                 },
    //                 {
    //                     month: "5月",
    //                     count: 22,
    //                 },
    //                 {
    //                     month: "6月",
    //                     count: 32,
    //                 },
    //             ],
    //         },
    //         {
    //             label: "",
    //             data: [
    //                 {
    //                     month: "1月",
    //                     count: 21,
    //                 },
    //                 {
    //                     month: "2月",
    //                     count: 18,
    //                 },
    //                 {
    //                     month: "3月",
    //                     count: 13,
    //                 },
    //                 {
    //                     month: "4月",
    //                     count: 23,
    //                 },
    //                 {
    //                     month: "5月",
    //                     count: 16,
    //                 },
    //                 {
    //                     month: "6月",
    //                     count: 17,
    //                 },
    //             ],
    //         },
    //     ],
    //     []
    // );
    const primaryAxis = useMemo(
        () => ({
            getValue: (datum) => datum.month,
        }),
        [],
    );
    const secondaryAxes = useMemo(
        () => [
            {
                getValue: (datum) => datum.count,
                elementType: "area",
            },
        ],
        [],
    );
    return (
        <div className="flex flex-col mr-8">
            <Title title="缺陷走势" />
            {data.length > 0 && (
                <Chart
                    options={{
                        data,
                        primaryAxis,
                        secondaryAxes,
                        dark: true,
                        padding: {
                            left: 20,
                            right: 20,
                            top: 40,
                            bottom: 40,
                        },
                    }}
                />
            )}
        </div>
    );
};

const distDefectionByModel = async () => {
    try {
        const rets = await dashboardService.getDefectionsByModel();
        return rets || [];
    } catch (error) {
        console.error('Failed to load defection distribution by model:', error);
        return [];
    }
};

const distDefectionByType = async () => {
    try {
        const rets = await dashboardService.getDefectionsByType();
        return rets || [];
    } catch (error) {
        console.error('Failed to load defection distribution by type:', error);
        return [];
    }
};

const DefectionTypeDistribution = () => {
    const { db } = useContext(Context);
    const [data, setData] = useState([]);
    const [data1, setData1] = useState([]);
    const loadData = async () => {
        let data = await distDefectionByModel();
        setData(data);
        let data1 = await distDefectionByType();
        setData1(data1);
    };
    useEffect(() => {
        if (!db) {
            return;
        }
        loadData();
    }, [db]);
    // const data = useMemo(
    //     () => [
    //         {
    //             subject: "机型1",
    //             value: 80,
    //         },
    //         {
    //             subject: "机型2",
    //             value: 80,
    //         },
    //         {
    //             subject: "机型3",
    //             value: 40,
    //         },
    //         {
    //             subject: "机型4",
    //             value: 60,
    //         },
    //         {
    //             subject: "机型5",
    //             value: 70,
    //         },
    //         {
    //             subject: "机型6",
    //             value: 90,
    //         },
    //     ],
    //     []
    // );
    // const data1 = useMemo(
    //     () => [
    //         {
    //             subject: "类型1",
    //             value: 70,
    //         },
    //         {
    //             subject: "类型2",
    //             value: 73,
    //         },
    //         {
    //             subject: "类型3",
    //             value: 90,
    //         },
    //         {
    //             subject: "类型4",
    //             value: 40,
    //         },
    //         {
    //             subject: "类型5",
    //             value: 50,
    //         },
    //         {
    //             subject: "类型6",
    //             value: 60,
    //         },
    //         {
    //             subject: "类型7",
    //             value: 70,
    //         },
    //         {
    //             subject: "类型8",
    //             value: 93,
    //         },
    //     ],
    //     []
    // );

    return (
        <div className="flex flex-col mr-8">
            <Title title="缺陷分布" />
            <div className="flex-1 grid grid-cols-2">
                <ResponsiveContainer
                    width="100%"
                    height="100%"
                    className="scale-75"
                >
                    <RadarChart cx="50%" cy="50%" data={data}>
                        <PolarGrid stroke="#333" opacity={0.3} />
                        <PolarAngleAxis
                            dataKey="name"
                            stroke="#fff"
                            opacity={0.5}
                        />
                        <PolarRadiusAxis stroke="#fff" opacity={0.5} />
                        <Radar
                            name="Hello"
                            dataKey="count"
                            stroke="#18A0FB"
                            fill="#18A0FB"
                            opacity={0.2}
                        />
                    </RadarChart>
                </ResponsiveContainer>
                <ResponsiveContainer
                    width="100%"
                    height="100%"
                    className="scale-75"
                >
                    <RadarChart cx="50%" cy="50%" data={data1}>
                        <PolarGrid stroke="#333" opacity={0.5} />
                        <PolarAngleAxis
                            dataKey="name"
                            stroke="#fff"
                            opacity={0.5}
                        />
                        <PolarRadiusAxis stroke="#fff" opacity={0.5} />
                        <Radar
                            name="Hello"
                            dataKey="count"
                            stroke="#18A0FB"
                            fill="#18A0FB"
                            opacity={0.2}
                        />
                    </RadarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};
const BlockItem = ({ icon, title, value }) => {
    return (
        <div className="flex flex-row gap-4 bg-block bg-no-repeat h-[90px] w-[210px]">
            <div className="flex items-center">
                <div className="ml-[20px] w-[56px] h-[52px]">{icon}</div>
            </div>
            <div className="flex-1 flex flex-col justify-center items-center mr-10	">
                <div className="text-[#EDE8E9] font-yahei text-sm font-normal">
                    {title}
                </div>
                <div className="text-[#EDEBE9] font-chakra text-3xl flex">
                    {value}
                </div>
            </div>
        </div>
    );
};
const BlockStat = () => {
    const icon1 = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="52"
            viewBox="0 0 56 52"
            fill="none"
        >
            <path
                d="M48.3842 42.8554C48.6887 42.9318 48.9792 43.1037 49.2137 43.3634L54.1628 48.7638C54.4816 49.1239 54.6579 49.6063 54.654 50.107C54.65 50.6077 54.4659 51.0866 54.1415 51.4407C53.817 51.7947 53.3781 51.9956 52.9192 51.9999C52.4604 52.0043 52.0183 51.8118 51.6882 51.464L46.7392 46.0636C46.5101 45.8148 46.349 45.5014 46.2737 45.1584C42.8228 48.3303 38.3825 49.9252 33.8797 49.6101C29.3769 49.295 25.1596 47.0944 22.1082 43.4675C19.0568 39.8407 17.407 35.0679 17.5033 30.1456C17.5996 25.2232 19.4345 20.5316 22.625 17.0502C25.8155 13.5687 30.115 11.5665 34.626 11.4614C39.137 11.3563 43.5109 13.1565 46.8346 16.4862C50.1584 19.8159 52.1751 24.4177 52.4638 29.3312C52.7526 34.2446 51.291 39.0898 48.3842 42.8554ZM35.0001 45.8306C36.8387 45.8307 38.6593 45.4357 40.3579 44.668C42.0566 43.9003 43.6001 42.775 44.9002 41.3564C46.2003 39.9378 47.2316 38.2537 47.9353 36.4002C48.6389 34.5466 49.001 32.56 49.001 30.5537C49.001 28.5475 48.6389 26.5609 47.9353 24.7073C47.2316 22.8538 46.2003 21.1696 44.9002 19.751C43.6001 18.3324 42.0566 17.2072 40.3579 16.4395C38.6593 15.6718 36.8387 15.2768 35.0001 15.2769C31.2871 15.2771 27.7264 16.8867 25.101 19.7517C22.4756 22.6166 21.0007 26.5022 21.0007 30.5537C21.0007 34.6053 22.4756 38.4909 25.101 41.3558C27.7264 44.2207 31.2871 45.8304 35.0001 45.8306ZM1.74973 0H54.2503C54.7144 8.37389e-05 55.1594 0.201311 55.4875 0.559423C55.8157 0.917535 56 1.4032 56 1.90961C56 2.41601 55.8157 2.90168 55.4875 3.25979C55.1594 3.61791 54.7144 3.81913 54.2503 3.81922H1.74973C1.28565 3.81913 0.840596 3.61791 0.512466 3.25979C0.184337 2.90168 0 2.41601 0 1.90961C0 1.4032 0.184337 0.917535 0.512466 0.559423C0.840596 0.201311 1.28565 8.37389e-05 1.74973 0ZM1.74973 22.9153H12.2498C12.7139 22.9154 13.159 23.1166 13.4871 23.4747C13.8152 23.8328 13.9996 24.3185 13.9996 24.8249C13.9996 25.3313 13.8152 25.817 13.4871 26.1751C13.159 26.5332 12.7139 26.7344 12.2498 26.7345H1.74973C1.28565 26.7344 0.840596 26.5332 0.512466 26.1751C0.184337 25.817 0 25.3313 0 24.8249C0 24.3185 0.184337 23.8328 0.512466 23.4747C0.840596 23.1166 1.28565 22.9154 1.74973 22.9153ZM1.74973 45.8306H15.7499C16.214 45.8307 16.659 46.0319 16.9871 46.39C17.3153 46.7481 17.4996 47.2338 17.4996 47.7402C17.4996 48.2466 17.3153 48.7323 16.9871 49.0904C16.659 49.4485 16.214 49.6497 15.7499 49.6498H1.74973C1.28565 49.6497 0.840596 49.4485 0.512466 49.0904C0.184337 48.7323 0 48.2466 0 47.7402C0 47.2338 0.184337 46.7481 0.512466 46.39C0.840596 46.0319 1.28565 45.8307 1.74973 45.8306Z"
                fill="url(#paint0_linear_39990_14871)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_39990_14871"
                    x1="28"
                    y1="0"
                    x2="28"
                    y2="52"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
            </defs>
        </svg>
    );
    const icon2 = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="58"
            viewBox="0 0 64 58"
            fill="none"
        >
            <g clipPath="url(#clip0_39992_14679)">
                <path
                    d="M31.8042 30.5225C34.5055 30.5225 36.6948 28.5602 36.6948 26.1483C36.6948 23.7317 34.5082 21.7765 31.8042 21.7765C29.1002 21.7765 26.9136 23.734 26.9136 26.1507C26.9136 28.5602 29.1002 30.5225 31.8042 30.5225ZM29.7322 33.7125L26.7109 57.9999H36.7909L33.7589 33.7149H29.7322V33.7125ZM52.3535 34.5027C48.2832 31.8338 44.0787 29.3371 39.7535 27.0207C39.661 26.9708 39.5564 26.9425 39.4488 26.9383C39.3413 26.9341 39.2344 26.9541 39.1375 26.9965C39.0406 27.0353 38.9559 27.0953 38.8911 27.1713C38.8264 27.2473 38.7837 27.3368 38.7669 27.4315C38.4836 28.9452 37.5844 30.3077 36.2469 31.2499C36.1629 31.3097 36.0964 31.3872 36.0532 31.4757C36.0099 31.5642 35.9913 31.6609 35.9989 31.7574C36.0149 31.9507 36.1429 32.1272 36.3322 32.231C44.7322 36.3684 54.6575 40.7933 57.5002 40.8585C57.8095 40.8513 58.2308 40.8126 58.5348 40.4308C58.6202 40.2945 58.6652 40.1404 58.6655 39.9837C58.4122 38.5652 55.9561 37.016 52.3535 34.5027ZM29.4122 20.5997C29.3124 20.6322 29.2055 20.6425 29.1003 20.6298C28.9952 20.617 28.8951 20.5815 28.8083 20.5263C28.7215 20.4711 28.6506 20.3978 28.6016 20.3126C28.5526 20.2273 28.527 20.1327 28.5269 20.0365C28.6522 12.9292 29.3189 5.53656 30.2681 2.15806C30.6869 1.07056 30.6815 0.23925 31.8975 0C33.1242 0.241685 33.1081 1.06818 33.5295 2.15806C33.8549 3.2915 34.1375 4.85268 34.3749 6.71831C34.8629 10.4279 35.1961 15.3072 35.2735 20.0342C35.2736 20.1309 35.248 20.2262 35.1988 20.312C35.1496 20.3979 35.0783 20.4717 34.9909 20.5272C34.8834 20.6006 34.7521 20.6397 34.6175 20.6383C34.5373 20.639 34.4577 20.6259 34.3829 20.5997C33.5893 20.3234 32.7475 20.1785 31.8975 20.1719C31.0281 20.1719 30.1962 20.3338 29.4122 20.5997ZM27.6309 31.6559C27.6193 31.7527 27.5822 31.8456 27.5228 31.9267C27.4634 32.0079 27.3834 32.0749 27.2895 32.1223C18.9483 36.2307 9.4042 40.252 6.55089 40.31C6.21752 40.3027 5.78289 40.2906 5.47089 39.875C5.3776 39.7414 5.32938 39.586 5.33214 39.4279C5.58552 38.002 7.97214 36.5472 11.5082 34.1427C15.0202 31.8637 19.6229 29.1812 24.0282 26.837C24.1199 26.7864 24.2241 26.7573 24.3314 26.7522C24.4387 26.7472 24.5456 26.7663 24.6427 26.808C24.7397 26.8497 24.8238 26.9127 24.8874 26.9911C24.951 27.0696 24.992 27.1611 25.0069 27.2575C25.2448 28.7769 26.0973 30.1619 27.3989 31.1435C27.5642 31.2668 27.6522 31.4625 27.6309 31.6559Z"
                    fill="url(#paint0_linear_39992_14679)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_39992_14679"
                    x1="31.9987"
                    y1="0"
                    x2="31.9987"
                    y2="57.9999"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <clipPath id="clip0_39992_14679">
                    <rect width="64" height="58" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
    const icon3 = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51"
            height="51"
            viewBox="0 0 51 51"
            fill="none"
        >
            <path
                d="M4.94852 9.08931L5.45347 10.9071H38.2753C39.2852 10.9071 40.0931 11.7151 40.0931 12.725V45.5468C40.0931 46.5567 39.2852 47.3646 38.2753 47.3646H5.45347C4.44357 47.3646 3.63565 46.5567 3.63565 45.5468V12.725C3.63565 11.7151 4.44357 10.9071 5.45347 10.9071L5.95842 9.08931L5.45347 7.27148C2.42377 7.27148 0 9.69525 0 12.725V45.5468C0 48.5765 2.42377 51.0002 5.45347 51.0002H38.2753C41.305 51.0002 43.7288 48.5765 43.7288 45.5468V12.725C43.7288 9.69525 41.305 7.27148 38.2753 7.27148H5.45347V9.08931H4.94852Z"
                fill="url(#paint0_linear_39990_14886)"
            />
            <path
                d="M12.7248 3.63565H45.5466C46.5565 3.63565 47.3644 4.44357 47.3644 5.45347V38.2753C47.3644 39.2852 48.1724 40.0931 49.1823 40.0931C50.1922 40.0931 51.0001 39.2852 51.0001 38.2753V5.45347C51.0001 2.42376 48.5763 7.6433e-08 45.5466 0H12.7248C11.7149 0 10.907 0.807921 10.907 1.81782C10.907 2.82772 11.7149 3.63565 12.7248 3.63565Z"
                fill="url(#paint1_linear_39990_14886)"
            />
            <path
                d="M14.6941 16.4106L15.199 18.2284C16.8654 18.2284 18.2287 19.5918 18.2287 21.2581C18.2287 22.9245 16.8654 24.2878 15.199 24.2878C13.5327 24.2878 12.1693 22.9245 12.1693 21.2581C12.1693 19.5918 13.5327 18.2284 15.199 18.2284L15.704 16.4106L15.199 14.5928C11.5129 14.5928 8.53369 17.572 8.53369 21.2581C8.53369 24.9443 11.5129 27.9235 15.199 27.9235C18.8852 27.9235 21.8644 24.9443 21.8644 21.2581C21.8644 17.572 18.8852 14.5928 15.199 14.5928V16.4106H14.6941Z"
                fill="url(#paint2_linear_39990_14886)"
            />
            <path
                d="M11.7147 43.0725L16.5117 37.3161L21.1573 41.9616C21.8642 42.6685 23.0256 42.6685 23.7325 41.9616C24.4395 41.2547 24.4395 40.0933 23.7325 39.3864L16.2593 31.9131L8.93748 40.7497C8.28104 41.5072 8.38203 42.6685 9.18995 43.325C9.89688 43.9309 11.0583 43.8299 11.7147 43.0725Z"
                fill="url(#paint3_linear_39990_14886)"
            />
            <path
                d="M23.8841 41.9617L28.4792 36.4577L34.3871 44.2845C34.993 45.0924 36.1544 45.2439 36.9623 44.6379C37.7702 44.032 37.9217 42.8706 37.3158 42.0627L28.6306 30.5498L21.0564 39.5884C20.3999 40.3459 20.5009 41.5072 21.3088 42.1637C22.0663 42.8201 23.2277 42.7191 23.8841 41.9617Z"
                fill="url(#paint4_linear_39990_14886)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_39990_14886"
                    x1="21.8644"
                    y1="7.27148"
                    x2="21.8644"
                    y2="51.0002"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_39990_14886"
                    x1="30.9535"
                    y1="0"
                    x2="30.9535"
                    y2="40.0931"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_39990_14886"
                    x1="15.199"
                    y1="14.5928"
                    x2="15.199"
                    y2="27.9235"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_39990_14886"
                    x1="16.3847"
                    y1="31.9131"
                    x2="16.3847"
                    y2="43.7186"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_39990_14886"
                    x1="29.1558"
                    y1="30.5498"
                    x2="29.1558"
                    y2="45.0082"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
            </defs>
        </svg>
    );
    const icon4 = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="53"
            height="48"
            viewBox="0 0 53 48"
            fill="none"
        >
            <g clipPath="url(#clip0_39990_14878)">
                <path
                    d="M27.8551 46.1747H1.83812V2.68162H17.9311L13.9973 19.0609C13.9079 19.4311 13.9973 19.7087 14.1761 19.9863C14.3549 20.2639 14.7125 20.449 14.9807 20.449H21.0603V37.1059C21.0603 37.5686 21.4179 38.0313 21.865 38.2164C22.312 38.3089 22.8484 38.1238 23.0272 37.6611L35.9016 12.3982C36.0805 12.1205 36.0805 11.6578 35.9016 11.3802C35.7228 11.1026 35.4546 10.825 35.097 10.825L26.7823 9.622L31.2526 2.68162H46.7197V23.6878C46.7197 24.3356 47.1668 24.7983 47.7926 24.7983C48.4184 24.7983 48.8655 24.3356 48.8655 23.6878V1.57116C48.8655 0.923395 48.4184 0.460703 47.7926 0.460703H30.7161C30.3585 0.460703 30.0009 0.64578 29.8221 0.923395L24.1001 9.80708C23.9213 10.0847 23.8319 10.5474 24.0107 10.9175C24.1895 11.2877 24.4577 11.4728 24.8154 11.5653L33.3089 12.8608L23.2061 32.479V19.246C23.2061 18.5982 22.759 18.1355 22.1332 18.1355H16.4112L20.3451 1.75624C20.4345 1.38609 20.3451 1.10847 20.1663 0.830856C19.9875 0.553241 19.6298 0.368164 19.3616 0.368164H0.765249C0.13941 0.368164 -0.307617 0.830857 -0.307617 1.47863V47.2851C-0.307617 47.9329 0.13941 48.3956 0.765249 48.3956H27.8551C28.481 48.3956 28.928 47.9329 28.928 47.2851C28.928 46.7299 28.481 46.1747 27.8551 46.1747Z"
                    fill="url(#paint0_linear_39990_14878)"
                />
                <path
                    d="M32.5042 32.5724C32.5042 33.2201 32.9512 33.6828 33.577 33.6828H56.3754C57.0013 33.6828 57.4483 33.2201 57.4483 32.5724C57.4483 31.9246 57.0013 31.4619 56.3754 31.4619H33.577C32.9512 31.4619 32.5042 31.9246 32.5042 32.5724ZM56.3754 40.3456H33.577C32.9512 40.3456 32.5042 40.8083 32.5042 41.4561C32.5042 42.1038 32.9512 42.5665 33.577 42.5665H56.3754C57.0013 42.5665 57.4483 42.1038 57.4483 41.4561C57.4483 40.8083 57.0013 40.3456 56.3754 40.3456ZM56.3754 46.1755H33.577C32.9512 46.1755 32.5042 46.6382 32.5042 47.286C32.5042 47.9337 32.9512 48.3964 33.577 48.3964H56.3754C57.0013 48.3964 57.4483 47.9337 57.4483 47.286C57.4483 46.7307 57.0013 46.1755 56.3754 46.1755Z"
                    fill="#1296DB"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_39990_14878"
                    x1="24.2789"
                    y1="0.368164"
                    x2="24.2789"
                    y2="48.3956"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <clipPath id="clip0_39990_14878">
                    <rect width="53" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
    const icon5 = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="54"
            viewBox="0 0 56 54"
            fill="none"
        >
            <path
                d="M15.3962 23.0149C15.3805 22.9362 15.3473 22.8617 15.299 22.7965C15.2507 22.7313 15.1883 22.6768 15.1162 22.6369C14.9482 22.5541 14.7802 22.5541 14.6384 22.6621C11.298 24.5789 8.03863 26.6242 4.86825 28.7929C2.09438 30.8161 0.246379 32.0329 0.0522461 33.2209C0.0522461 33.3037 0.0783794 33.4657 0.164246 33.5989C0.414379 33.9517 0.75038 33.9517 1.00425 33.9769C3.24425 33.9229 10.6922 30.5461 17.1882 27.0901C17.3301 27.0109 17.4421 26.8741 17.4421 26.7121C17.4682 26.5501 17.3861 26.3881 17.2741 26.2801C16.2427 25.4597 15.5718 24.2931 15.3962 23.0149ZM20.8581 25.9309C21.8389 25.889 22.7651 25.4839 23.4437 24.7998C24.1224 24.1158 24.5012 23.2056 24.5012 22.2589C24.5012 21.3123 24.1224 20.4021 23.4437 19.718C22.7651 19.034 21.8389 18.6288 20.8581 18.5869C19.8773 18.6288 18.9511 19.034 18.2725 19.718C17.5938 20.4021 17.215 21.3123 17.215 22.2589C17.215 23.2056 17.5938 24.1158 18.2725 24.7998C18.9511 25.4839 19.8773 25.889 20.8581 25.9309ZM18.4501 17.2621C18.5882 17.3701 18.7562 17.3701 18.9242 17.3161C19.5402 17.1001 20.1861 16.9669 20.8581 16.9669C21.5301 16.9669 22.1722 17.1001 22.7882 17.3161C22.8442 17.3449 22.9002 17.3449 22.9861 17.3449C23.0981 17.3449 23.1802 17.3161 23.2661 17.2621C23.3356 17.2185 23.3926 17.1587 23.4317 17.0882C23.4709 17.0177 23.491 16.9389 23.4901 16.8589C23.4513 13.1239 23.217 9.39318 22.7882 5.68093C22.6457 4.39089 22.4213 3.11049 22.1162 1.84693C21.7802 0.928933 21.8101 0.226933 20.8581 0.0361328C19.9061 0.226933 19.9061 0.928933 19.5962 1.84693C18.8682 4.68013 18.3381 10.8901 18.2261 16.8589C18.2261 16.9921 18.3082 17.1541 18.4501 17.2621ZM36.9002 29.1421C34.1002 27.1441 30.4602 24.8221 27.0741 22.8529C27.0014 22.8148 26.921 22.7925 26.8385 22.7876C26.7559 22.7826 26.6733 22.7951 26.5962 22.8241C26.4581 22.8781 26.3461 23.0149 26.3162 23.2021C26.0922 24.4981 25.3642 25.6321 24.3562 26.4169C24.2922 26.4701 24.2414 26.5366 24.2078 26.6115C24.1742 26.6863 24.1585 26.7675 24.1621 26.8489C24.1621 27.0109 24.2741 27.1729 24.4122 27.2521C30.9642 30.7369 38.6922 34.4377 40.9322 34.4881C41.1861 34.4881 41.4922 34.4629 41.7461 34.1389C41.8182 34.025 41.8569 33.8944 41.8581 33.7609C41.6341 32.5477 39.7002 31.2517 36.9002 29.1421ZM21.3882 28.3861H20.4922C20.011 28.3974 19.5535 28.5905 19.2184 28.9238C18.8832 29.2571 18.6972 29.7039 18.7002 30.1681L17.8042 51.9589C17.8042 52.9309 18.6181 53.7409 19.5962 53.7409H22.2842C23.2661 53.7409 24.0762 52.9309 24.0762 51.9589L23.184 30.1681C23.1871 29.7039 23.001 29.2571 22.6659 28.9238C22.3307 28.5905 21.8733 28.3974 21.392 28.3861H21.3882Z"
                fill="url(#paint0_linear_39990_14887)"
                fillOpacity="0.83"
            />
            <path
                d="M36.9302 33.516C36.9302 33.408 36.8443 33.3288 36.7622 33.2748C36.6502 33.2208 36.5382 33.2208 36.4523 33.2748C34.2982 34.5168 32.0283 35.9496 30.2923 37.1376C28.5563 38.4048 27.3803 39.1896 27.2422 39.9456C27.2422 39.9996 27.2422 40.1076 27.2982 40.1868C27.4363 40.4028 27.6603 40.4028 27.8283 40.4316C29.2283 40.4028 33.9323 38.2716 38.0502 36.0828C38.1359 36.0259 38.1959 35.9397 38.2182 35.8416C38.2182 35.7336 38.1883 35.6256 38.1062 35.5716C37.4689 35.0479 37.0509 34.3186 36.9302 33.5196V33.516ZM40.4022 35.352C40.7184 35.352 41.0315 35.292 41.3237 35.1753C41.6158 35.0586 41.8813 34.8876 42.1049 34.6719C42.3285 34.4563 42.5059 34.2003 42.6269 33.9186C42.7479 33.6369 42.8102 33.335 42.8102 33.03C42.8102 32.7251 42.7479 32.4232 42.6269 32.1414C42.5059 31.8597 42.3285 31.6038 42.1049 31.3881C41.8813 31.1725 41.6158 31.0015 41.3237 30.8848C41.0315 30.7681 40.7184 30.708 40.4022 30.708C39.7635 30.708 39.1511 30.9527 38.6995 31.3881C38.2479 31.8236 37.9942 32.4142 37.9942 33.03C37.9942 33.6459 38.2479 34.2365 38.6995 34.6719C39.1511 35.1074 39.7635 35.352 40.4022 35.352ZM38.8603 29.8728C38.9046 29.9041 38.9569 29.923 39.0116 29.9274C39.0662 29.9318 39.1211 29.9217 39.1702 29.898C39.9654 29.6157 40.839 29.6157 41.6342 29.898C41.6603 29.9268 41.7163 29.9268 41.7462 29.9268C41.8139 29.9213 41.8799 29.9029 41.9403 29.8728C41.9845 29.8419 42.0204 29.8013 42.0451 29.7544C42.0698 29.7074 42.0825 29.6555 42.0822 29.6028C42.062 27.2389 41.9124 24.8776 41.6342 22.5288C41.5535 21.7102 41.4125 20.8982 41.2123 20.0988C41.0182 19.53 41.0182 19.0728 40.4022 18.9648C39.8123 19.098 39.8123 19.53 39.5883 20.0988C39.1142 21.8808 38.8043 25.8228 38.7222 29.574C38.7222 29.7108 38.7782 29.8188 38.8603 29.8728ZM50.5083 37.3788C48.5037 35.9607 46.4293 34.6368 44.2923 33.4116C44.2102 33.3576 44.0982 33.3576 43.9862 33.3828C43.9003 33.4368 43.8182 33.5196 43.8182 33.6276C43.682 34.4261 43.2429 35.1471 42.5862 35.6508C42.5413 35.6795 42.5065 35.7207 42.4865 35.769C42.4665 35.8172 42.4622 35.8702 42.4742 35.9208C42.4742 36.0288 42.5302 36.1116 42.6422 36.1656C46.7862 38.3508 51.6582 40.7016 53.0582 40.7268C53.2262 40.7268 53.4203 40.7016 53.5622 40.5108C53.6182 40.4316 53.6182 40.3488 53.6182 40.2696C53.5062 39.5388 52.3003 38.7036 50.5083 37.3788ZM40.7083 36.9216H40.1483C39.8446 36.9311 39.557 37.0552 39.3474 37.2674C39.1379 37.4796 39.0233 37.7627 39.0283 38.0556L38.4683 51.7968C38.4633 52.0898 38.5779 52.3729 38.7874 52.5851C38.997 52.7972 39.2846 52.9214 39.5883 52.9308H41.2982C41.6019 52.9214 41.8895 52.7972 42.0991 52.5851C42.3086 52.3729 42.4232 52.0898 42.4182 51.7968L41.8582 38.0556C41.8607 37.9082 41.8328 37.7617 41.7762 37.6247C41.7196 37.4877 41.6354 37.3629 41.5285 37.2574C41.4216 37.152 41.294 37.068 41.1533 37.0104C41.0125 36.9527 40.8613 36.9226 40.7083 36.9216Z"
                fill="url(#paint1_linear_39990_14887)"
                fillOpacity="0.83"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_39990_14887"
                    x1="20.9552"
                    y1="0.0361328"
                    x2="20.9552"
                    y2="53.7409"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_39990_14887"
                    x1="40.4302"
                    y1="18.9648"
                    x2="40.4302"
                    y2="52.9308"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
            </defs>
        </svg>
    );

    const icon6 = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="59"
            height="59"
            viewBox="0 0 59 59"
            fill="none"
        >
            <path
                d="M57.3886 22.3757H54.8774V12.5596C54.8774 11.5124 54.1546 10.6642 53.2659 10.6642H43.1806V9.27037C43.1806 8.22312 42.4616 7.375 41.5729 7.375H21.2732C20.3882 7.375 19.6654 8.22312 19.6654 9.27037V10.6642H9.57644C8.68775 10.6642 7.965 11.5124 7.965 12.5596V17.4124C7.965 17.4124 3.6875 17.2759 3.6875 22.3168V32.509C3.6875 37.5498 7.965 37.4171 7.965 37.4171V42.2219C7.965 43.2691 8.68406 44.1209 9.57644 44.1209H18.4928C17.6041 44.1209 16.8814 44.9691 16.8814 46.0163V49.7296C16.8814 50.7769 17.6041 51.625 18.4928 51.625H44.3496C45.2383 51.625 45.961 50.7769 45.961 49.7296V46.0163C45.961 44.9691 45.2383 44.1209 44.3496 44.1209H53.2659C54.1546 44.1209 54.8774 43.2728 54.8774 42.2219V32.4131H57.3886C58.2809 32.4131 59 31.5613 59 30.5141V24.2711C59 23.2239 58.2809 22.3757 57.3886 22.3757ZM22.2393 39.5005V11.9918C22.2393 11.1178 22.8035 10.4098 23.4967 10.4098H39.3456C40.0389 10.4098 40.5994 11.1178 40.5994 11.9954V44.1209H22.243V39.5005H22.2393ZM11.9733 41.0861C11.1842 41.0861 10.5426 40.3892 10.5426 39.5337V15.2515C10.5426 14.396 11.1842 13.7028 11.9733 13.7028H19.6654V41.0861H11.9733ZM43.3834 48.5902H19.4589V47.0746H43.3834V48.5902ZM52.2998 24.0314C52.2919 24.1111 52.2882 24.1911 52.2887 24.2711V30.5141C52.288 30.5953 52.2917 30.6766 52.2998 30.7574V39.5337C52.2998 40.3892 51.6582 41.0824 50.8691 41.0824H43.1769V13.7028H50.8691C51.6582 13.7028 52.2998 14.3997 52.2998 15.2552V24.0314ZM56.2086 29.0464H54.8774V25.7388H56.2122V29.0538L56.2086 29.0464Z"
                fill="url(#paint0_linear_39990_14867)"
            />
            <path
                d="M34.9686 22.125H30.7021L25.8125 32.4758L31.1594 32.627L28.7514 40.5625L36.875 28.6224H31.6129L34.9686 22.125Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_39990_14867"
                    x1="31.3438"
                    y1="7.375"
                    x2="31.3438"
                    y2="51.625"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" stopOpacity="0.89" />
                    <stop offset="1" stopColor="#0078D4" stopOpacity="0.89" />
                </linearGradient>
            </defs>
        </svg>
    );
    const icon7 = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
        >
            <g clipPath="url(#clip0_39990_14950)">
                <path
                    d="M39.0625 26.5625H34.0625L31.25 15.3125C30.9375 14.6875 30.3125 14.0625 29.6875 14.0625C29.0625 14.0625 28.4375 14.375 28.125 15L23.75 28.75L21.875 21.5625C21.5625 20.9375 20.9375 20.3125 20.3125 20.3125C19.6875 20.3125 19.0625 20.625 18.75 21.25L16.25 26.5625H10.9375C10 26.5625 9.375 27.5 9.375 28.125C9.375 29.0625 10 29.6875 10.9375 29.6875H17.1875C17.8125 29.6875 18.4375 29.375 18.4375 28.75L19.6875 26.25L21.875 34.6875C22.1875 35.3125 22.5 35.9375 23.4375 35.9375C24.0625 35.9375 24.6875 35.625 25 35L29.375 21.25L31.25 28.4375C31.5625 29.0625 32.1875 29.6875 32.8125 29.6875H39.0625C40 29.6875 40.625 28.75 40.625 28.125C40.625 27.1875 40 26.5625 39.0625 26.5625Z"
                    fill="url(#paint0_linear_39990_14950)"
                />
                <path
                    d="M25 50C11.25 50 0 38.75 0 25C0 11.25 11.25 0 25 0C30.3125 0 35.3125 1.5625 39.6875 4.6875C40.3125 5.3125 40.625 6.25 40 6.875C39.375 7.5 38.4375 7.8125 37.8125 7.1875C34.0625 4.375 29.6875 3.125 25 3.125C12.8125 3.125 3.125 12.8125 3.125 25C3.125 37.1875 12.8125 46.875 25 46.875C37.1875 46.875 46.875 37.1875 46.875 25C46.875 21.25 45.9375 17.5 44.0625 14.0625C43.75 13.4375 43.75 12.5 44.6875 11.875C45.3125 11.5625 46.25 11.5625 46.875 12.5C48.75 16.25 50 20.625 50 25C50 38.75 38.75 50 25 50Z"
                    fill="url(#paint1_linear_39990_14950)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_39990_14950"
                    x1="25"
                    y1="14.0625"
                    x2="25"
                    y2="35.9375"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_39990_14950"
                    x1="25"
                    y1="0"
                    x2="25"
                    y2="50"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <clipPath id="clip0_39990_14950">
                    <rect width="50" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
    const icon8 = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
        >
            <g clipPath="url(#clip0_39990_14957)">
                <path
                    d="M25.0012 49.3945C11.1925 49.3945 -0.0388184 38.444 -0.0388184 24.9805C-0.0388184 11.5169 11.1925 0.566406 25.0012 0.566406C38.81 0.566406 50.0413 11.5169 50.0413 24.9805C50.0413 38.444 38.81 49.3945 25.0012 49.3945ZM25.0012 3.49609C12.8485 3.49609 2.96599 13.1315 2.96599 24.9805C2.96599 36.8294 12.8485 46.4648 25.0012 46.4648C37.154 46.4648 47.0365 36.8294 47.0365 24.9805C47.0365 13.1315 37.154 3.49609 25.0012 3.49609Z"
                    fill="url(#paint0_linear_39990_14957)"
                />
                <path
                    d="M35.8588 29.0758C35.8588 29.0758 33.1211 27.1227 29.3417 26.1527C28.7207 27.4092 27.4253 29.9482 26.6508 30.8597V29.9678C26.6508 29.4144 26.2101 28.7373 26.2101 28.3662C26.2101 27.9951 26.6841 27.904 26.6841 27.4417C26.6841 26.9795 26.4237 26.9795 25.6492 26.9795H25.3086C24.5407 26.9795 24.2736 26.9795 24.2736 27.4417C24.2736 27.904 24.7477 27.9951 24.7477 28.3662C24.7477 28.7373 24.307 29.4144 24.307 29.9678V30.8597C23.5191 29.9287 22.1903 27.305 21.5893 26.0811C17.6497 27.0186 14.7651 29.0758 14.7651 29.0758V34.805H35.8655V29.0758H35.8588ZM32.0995 20.6774C32.0995 21.3285 31.7656 21.9274 31.2848 22.3701C31.9993 23.4508 32.9208 24.193 33.8356 24.193C35.1711 24.193 36.5399 22.6045 37.221 20.6774H37.2277C37.7018 20.6774 38.5097 20.1761 38.5097 19.5641C38.5097 18.9456 38.1224 18.4508 37.655 18.4508H37.6484C37.6484 18.3923 37.655 18.3271 37.655 18.2686C37.655 15.4495 35.7119 13.9977 33.8356 13.9977C32.5068 13.9977 31.1379 14.7334 30.4568 16.1787C30.7573 16.8232 30.9844 17.6045 31.0578 18.5485C31.6855 18.9782 32.0995 19.7594 32.0995 20.6774ZM29.6489 25.0068C30.2832 25.1696 30.8909 25.3584 31.4651 25.5602C31.1713 25.0003 30.9042 24.4665 30.7173 24.0954C30.3033 24.193 29.9026 24.3102 29.522 24.4339C29.4219 24.5902 29.3217 24.7464 29.2149 24.8962L29.6489 25.0068ZM37.2143 24.154C36.8137 24.9678 36.0658 26.4326 35.4515 27.4027C36.1326 27.7998 36.5332 28.0798 36.5733 28.1123L37.0741 28.4704V31.4066H42.6831V26.6019C42.6831 26.6019 40.3927 24.9678 37.2143 24.154ZM34.1227 24.8441H33.8356C33.1879 24.8441 32.9675 24.8441 32.9675 25.2347C32.9675 25.6188 33.3682 25.7035 33.3682 26.0094C33.3682 26.0941 33.3415 26.1917 33.3014 26.3024C33.9224 26.5824 34.4699 26.8623 34.9307 27.1162C34.8439 26.7061 34.5901 26.2699 34.5901 26.0094C34.5901 25.6969 34.9908 25.6188 34.9908 25.2347C34.9908 24.8441 34.7704 24.8441 34.1227 24.8441ZM19.5461 18.6787C19.5794 18.0407 19.693 17.4743 19.8532 16.973C19.3791 14.9548 17.7565 13.9131 16.174 13.9131C14.2977 13.9131 12.3545 15.3714 12.3545 18.1904C12.3545 18.2555 12.3612 18.3206 12.3612 18.3923C11.9472 18.4704 11.6267 18.9261 11.6267 19.4925C11.6267 20.0589 12.3011 20.5212 12.7819 20.5928C13.4563 22.5329 14.8318 24.1279 16.1673 24.1279C17.209 24.1279 18.2707 23.1644 19.0119 21.8167C18.8049 21.4782 18.6713 21.1006 18.6713 20.6839C18.678 19.8701 19.0119 19.141 19.5461 18.6787ZM7.31982 26.5303V31.3415H13.5364V28.4704L14.0372 28.1188C14.0773 28.0928 14.4045 27.8584 14.9654 27.5264C14.311 26.5433 13.4697 24.8766 13.049 24.0238C9.7437 24.805 7.31982 26.5303 7.31982 26.5303ZM16.4611 24.7725H16.174C15.5263 24.7725 15.3059 24.7725 15.3059 25.1566C15.3059 25.5472 15.7066 25.6253 15.7066 25.9313C15.7066 26.2438 15.3326 26.8102 15.3326 27.279V27.3115C15.8001 27.0446 16.3877 26.7386 17.0621 26.4196C16.9886 26.2308 16.9285 26.055 16.9285 25.9313C16.9285 25.6188 17.3292 25.5472 17.3292 25.1566C17.3225 24.7725 17.1021 24.7725 16.4611 24.7725ZM19.5527 24.0824C19.3391 24.512 19.0386 25.111 18.7047 25.736C19.4993 25.4365 20.3674 25.1566 21.2955 24.9352L21.409 24.9092C21.3423 24.8115 21.2755 24.7139 21.2087 24.6097C20.6879 24.4144 20.1403 24.2321 19.5527 24.0824Z"
                    fill="url(#paint1_linear_39990_14957)"
                />
                <path
                    d="M30.8841 20.6774C30.8841 19.9417 30.4233 19.3493 29.8624 19.3493H29.8558C29.8558 19.2777 29.8624 19.2061 29.8624 19.1279C29.8624 15.7686 27.5454 14.0303 25.3085 14.0303C23.0716 14.0303 20.7545 15.7686 20.7545 19.1279C20.7545 19.2061 20.7612 19.2842 20.7612 19.3688C20.2671 19.46 19.8865 20.0068 19.8865 20.6774C19.8865 21.348 20.6944 21.9014 21.262 21.986C22.0633 24.2972 23.7059 26.1982 25.3018 26.1982C26.8977 26.1982 28.527 24.3102 29.3349 22.0055H29.3483C29.9159 22.0055 30.8841 21.4066 30.8841 20.6774Z"
                    fill="url(#paint2_linear_39990_14957)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_39990_14957"
                    x1="25.0012"
                    y1="0.566406"
                    x2="25.0012"
                    y2="49.3945"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_39990_14957"
                    x1="25.0014"
                    y1="13.9131"
                    x2="25.0014"
                    y2="34.805"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_39990_14957"
                    x1="25.3853"
                    y1="14.0303"
                    x2="25.3853"
                    y2="26.1982"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#0078D4" />
                </linearGradient>
                <clipPath id="clip0_39990_14957">
                    <rect width="50" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );

    const { db } = useContext(Context);
    const { height: windowHeight } = useWindowSize();
    const [ref, { height }] = useElementSize();
    if (height > 10) {
        let h = ((height - 10) * 100) / windowHeight;
        document.body.style.setProperty("--dashboard-bottom-height", `${h}%`);
    }
    const [data, setData] = useState({});
    const loadData = async () => {
        let data = await statTotal();
        setData(data);
    };
    useEffect(() => {
        if (!db) {
            return;
        }
        loadData();
    }, [db]);
    return (
        <div
            className="grid grid-cols-4 gap-4 place-content-center place-items-center px-4"
            ref={ref}
        >
            <BlockItem icon={icon1} title="巡检总次数" value={data.taskCount} />
            <BlockItem
                icon={icon2}
                title="检测总机数"
                value={data.detectTurbineCount}
            />
            <BlockItem
                icon={icon3}
                title="照片检测量"
                value={data.frameCount}
            />
            <BlockItem
                icon={icon4}
                title="缺陷发现量"
                value={data.defectionCount}
            />
            <BlockItem
                icon={icon5}
                title="风场总数量"
                value={data.fieldItemCount}
            />
            <BlockItem
                icon={icon6}
                title="风机总数量"
                value={data.turbineCount}
            />
            <BlockItem icon={icon7} title="总功率/MW" value={data.powerSum} />
            <BlockItem
                icon={icon8}
                title="工作员总数"
                value={data.workerCount}
            />
        </div>
    );
};

const statTotal = async () => {
    try {
        const stats = await dashboardService.getDashboardStats();
        return stats || {
            taskCount: 0,
            detectTurbineCount: 0,
            frameCount: 0,
            defectionCount: 0,
            fieldItemCount: 0,
            turbineCount: 0,
            powerSum: 0,
            workerCount: 0,
        };
    } catch (error) {
        console.error('Failed to load dashboard statistics:', error);
        return {
            taskCount: 0,
            detectTurbineCount: 0,
            frameCount: 0,
            defectionCount: 0,
            fieldItemCount: 0,
            turbineCount: 0,
            powerSum: 0,
            workerCount: 0,
        };
    }
};

const initMap = (items) => {
    let map = L.map("map", {
        // hide all controls
        attributionControl: false,
        zoomControl: false,
        // disable all interactions
        // closePopupOnClick: false,
        // boxZoom: false,
        // doubleClickZoom: false,
        // dragging: false,
        // keyboard: false,
        // scrollWheelZoom: false,
        // tap: false,
        // touchZoom: false,

        // center & zoom(接近兰州)
        center: [33.0, 103.82],
        zoom: 4.8,
    });
    L.tileLayer
        // .chinaProvider("Geoq.Normal.PurplishBlue", { maxZoom: 18, minZoom: 5 })
        // .chinaProvider("TianDiTu.Normal.Map", { maxZoom: 18, minZoom: 5 })
        .chinaProvider("GaoDe.Normal.Map", { maxZoom: 18, minZoom: 5 })
        // .chinaProvider("GaoDe.Normal.Map", { maxZoom: 18, minZoom: 5 })
        .addTo(map);

    // 模拟一个风场的添加
    for (let item of items) {
        let lat = item.latitude;
        let lng = item.longitude;
        if (!lat || !lng) {
            continue;
        }
        // let lat = 36.07;
        // let lng = 103.82;
        let marker = L.circleMarker([lat, lng], {
            color: "#1696D7",
            fillColor: "#1482D6",
            fillOpacity: 0.5,
            radius: 8,
        }).addTo(map);
        // let text = `${item.name} <br /> 风机:${item.turbineCount}`;
        let text = `${item.name}`;
        marker.bindTooltip(text, {
            // permanent: true,
            direction: "top",
            offset: { x: 0, y: -10 },
        });
    }
};

export const GMap = () => {
    let [mapInited, setMapInited] = useState(false);
    let [items, setItems] = useState([]);
    let { db } = useContext(Context);

    const loadData = async () => {
        console.warn("loadData function for map items is not yet implemented in backend");
        try {
            const items = [];
            console.log("field_items for map:", items);
            setItems(items);
            if (!mapInited) {
                initMap(items);
                setMapInited(true);
            }
        } catch (error) {
            console.error("Error in loadData for map:", error);
            setItems([]);
        }
    };
    useEffect(() => {
        if (!db) {
            return;
        }
        loadData();
    }, [db]);
    return (
        <div
            id="map1"
            className="flex-1 opacity-[0] invisible"
            style={{ width: "100%", height: "100%" }}
        ></div>
    );
};

export const Dashboard = () => {
    const { now } = useNow();
    const appName =
        process.env.REACT_APP_APP_NAME || "风电叶片外部巡检数据平台";

    return (
        <div
            className="flex flex-col flex-1 w-full h-full bg-cover bg-no-repeat"
            style={{ backgroundImage: "url(/bg17.jpg)" }}
        >
            <div
                className="w-full"
                style={{ position: "relative", height: 120 }}
            >
                <div
                    className="flex flex-row relative"
                    style={{
                        position: "absolute",
                        left: 66,
                        top: 18,
                        zoom: 1.2,
                    }}
                >
                    <img
                        src="/bowongtec-logo.png"
                        style={{
                            width: 144,
                            height: 144,
                        }}
                        alt="上海伯望 Logo"
                    />
                </div>
                <div
                    style={{
                        color: "#fff",
                        textAlign: "center",
                        fontFamily: "Microsoft YaHei",
                        fontSize: 36,
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "normal",
                        width: 489,
                        height: 73,
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        top: 30,
                    }}
                >
                    {appName}
                </div>
                <div
                    style={{
                        color: "#fff",
                        fontFamily: "Chakra Petch",
                        fontSize: 16,
                        fontStyle: "normal",
                        fontWeight: 400,
                        position: "absolute",
                        right: 90,
                        top: 36,
                    }}
                >
                    {toDateWeekdayTimeString(now)}
                </div>
            </div>
            <div
                className="flex-1 grid relative"
                style={{
                    gridTemplateAreas: `
            a x b 
            a x c 
            d x e 
            f y g`,
                    gridTemplateRows: "1fr 1fr 1fr 1fr",
                    gridTemplateColumns:
                        "minmax(400px, auto) 1fr minmax(400px, auto)",
                }}
            >
                <div
                    id="map"
                    className="absolute left-0 top-0 right-0 bottom-0 w-full h-full z-[0]"
                ></div>
                <FieldStat />
                <div className="row-span-3">
                    <GMap />
                </div>
                <TaskStat />
                <DefectionCountByMonthStat />
                <TurbineStat />
                <DefectionTypeByMonthStat />
                <UserStat />
                <BlockStat />
                <DefectionTypeDistribution />
            </div>
        </div>
    );
};
